import { render, staticRenderFns } from "./MyWalletOrbitScrollableTable.vue?vue&type=template&id=0056faf1&scoped=true"
import script from "./MyWalletOrbitScrollableTable.vue?vue&type=script&lang=ts"
export * from "./MyWalletOrbitScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletOrbitScrollableTable.vue?vue&type=style&index=0&id=0056faf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0056faf1",
  null
  
)

export default component.exports